<template>
    <div>
        <header>
            <ul>
                <li><router-link to="/company">
                    <img src="@/assets/img/logo.png"></router-link>
                </li>
                <li><router-link to="/">首页</router-link></li>
                <li><router-link to="/products">产品</router-link></li>
                <!-- <li><router-link to=''>产品服务</router-link></li> -->
                <li><router-link to='/successCases'>成功案例</router-link></li>
                <li><router-link to='/contact'>联系方式</router-link></li>
            </ul>
        </header>
    </div>
</template>

<script>
  export default {
    name: 'NavPage',
    data() {
      return {
      };
    },
  }
</script>

<style scoped>
header {
    width: 100%;
    height: auto;
    
}
header ul {
    width: 100%;
    height: 80px;
    padding: 0;
    background-color: white;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0;
    font-size: 18px;
    position: fixed;
    top: 0;
    border: 0;
    z-index: 1000;
}
header ul li {
    list-style: none;
    color: #8f8f8f;
}
header a {
    text-decoration: none;
    color: #8f8f8f;
}
header li :hover {
    color: blue;
}
</style>